import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import { useState } from "react";
import { Card, Grid } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";

import { useCustomerValue } from "providers/CustomerContext";
import { InboundLayout } from "ui-components/Layout";
import { LoadingDialog } from "ui-components/Alert";
import { SelectFields } from "ui-components/Form";
import { downloadPDF2, downloadFile } from "layouts/views/common/file";
import { Error_ } from "ui-components/Alert";
import { getManifestNumberOptions } from "services/data.test.service";
import { getManifestReport } from "services/data.report.service";
import { useTeamValue } from "providers/TeamContext";

function ManifestReport() {
  const {permissions, allowAll} = useTeamValue()
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ content="Invalid Request" onChange={setAlert} />);
  const exportPermission = allowAll || (Boolean(permissions["Manifest Report_Report"]) && permissions["Manifest Report_Report"].findIndex(b => b==="export") !== -1);

  const downloadReportMutation = useMutation(getManifestReport, {
    onSuccess: (response) => {
      if (reportType === "PDF") {
        downloadPDF2(response.data,`${pickslipNumber}.pdf`);
      } else {
        downloadFile(response.data, `${pickslipNumber}.csv`);
      }
    },
    onError,
  });

  const [pickslipNumberOptions, setpickslipNumberOptions] = useState([]);
  const [pickslipNumber, setPickslipNumber] = useState([]);
  const [reportType, setReportType] = useState("PDF");

  const handleSubmit = () => {
    downloadReportMutation.mutate({
      manifest_numbers: pickslipNumber,
    });
  };

  useQuery({
    queryKey: ["report-manifest1"],
    queryFn: () => getManifestNumberOptions(),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      setpickslipNumberOptions(data.data.data);
    },
  });

  const downloadStatus = downloadReportMutation.status === "loading";

  return (
    <InboundLayout>
      {downloadStatus && <LoadingDialog />}

      <Card sx={{ height: "100%" }}>
        <MDBox p={3}>
          {alert}
          <MDBox pb={3}>
            <MDTypography color="info" variant="h3">
              Export Manifest Report
            </MDTypography>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <SelectFields
                field={{
                  name: "manifestNumber",
                  label: "Manifest Number",
                  value: pickslipNumber,
                  errors: {},
                  required: true,
                  multiple: true,
                }}
                options={pickslipNumberOptions}
                onChange={(e, v) => setPickslipNumber(v)}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectFields
                field={{
                  name: "reportType",
                  label: "Export to File Type *",
                  value: reportType,
                  errors: {},
                  required: true,
                }}
                options={["PDF"]}
                onChange={(e, v) => setReportType(v)}
              />
            </Grid>
          </Grid>

          <MDBox mt={2} display="flex" justifyContent="center">
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              disabled={!Boolean(pickslipNumber) || !exportPermission}
              onClick={handleSubmit}
            >
              Download
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </InboundLayout>
  );
}

export default ManifestReport;
